import { createSelector } from "reselect";

import { selectFeatureFlags } from "ee/selectors/featureFlagsSelectors";

/**
 * Checks if the release_query_module_enabled feature flag is enabled. This is the base condition for enabling
 * query modules + the base functionalities of packages.
 *
 * @returns boolean
 */
export const getShowQueryModule = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    return featureFlags.release_query_module_enabled;
  },
);

/**
 * Checks if the release_ui_module_enabled feature flag is enabled. This is the base condition for enabling
 * ui modules only. To enable all features and UI modules both release_query_module_enabled
 * and release_ui_module_enabled has to be enabled
 *
 * @returns boolean
 */
export const getShowUIModule = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    return featureFlags.release_ui_module_enabled;
  },
);

export const getPackagePullFeature = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    return featureFlags.release_jit_package_pull_enabled;
  },
);

// feature flag for enabling git in packages
export const selectGitPackageEnabled = createSelector(
  selectFeatureFlags,
  (featureFlags) => {
    return featureFlags.release_git_package_enabled;
  },
);
